import type { Measure } from "./types";

export function measureAlias(measure: Measure): string {
  return (
    measure.alias ?? `${measure.func}_${measure.field}`.replace("*", "all")
  );
}
